import type { Product } from '~/api/products/types';

export const isProductSelectable = ({ status }: { status: Product['status'] }) => status !== 'Rejected';
